module.exports = __webpack_public_path__ + "img/drag-and-drop-active.22dc2449.svg";